import React from 'react';
import { Row, Col } from 'react-bootstrap';

/**
 * !! HAS A MODERN TWIN: projectProperties/modern/PropertySwitch.jsx !!
 *
 * That file is a verbatim copy of everything in this class except render(). Any change
 * to the state machine, the handlers or componentDidUpdate MUST be mirrored there, or
 * the two will drift and screens will behave differently depending on which variant
 * they import. Only the layout is allowed to differ.
 *
 * This duplication is temporary: see the note in modern/PropertySwitch.jsx for how to
 * collapse the two once the modern layout has settled.
 */
export default class PropertySwitch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.property.value === "1"
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        const value = e.target.checked;
        this.setState({
            isChecked: value
        });

        this.props.handleChange(this.props.property.info.name, value ? "1" : "0");
    }

    componentDidUpdate(prevProps) {
        if (this.props.property.value !== prevProps.property.value) {
            this.setState({isChecked: this.props.property.value === "1" });
        }
    }

    render() {

        return (
            <Row style={{ margin: "0.75rem auto 0" }} className={this.props.className}>
                <Col sm="6" style={{ padding: '0' }}>
                    {/* {this.props.property.info.displayName.replace(/([A-Z])/g, ' $1')} */}
                    {this.props.title}
                </Col>

                <Col sm="6" style={{ padding: '0', display: 'flex', justifyContent: 'flex-end' }}>
                    <label className="switch">
                        <input
                            disabled={this.props.disabled}
                            name={this.props.property.info.name}
                            type="checkbox"
                            checked={this.state.isChecked}
                            onChange={this.handleChange} />
                        <span className="slider round"></span>
                    </label>
                </Col>
            </Row>
        );
    };
}
